module.exports = __webpack_public_path__ + "img/nav-pay.40e8e7f2.svg";